import { useState } from "react";
import api from "@/lib/api";
import { formatApiError } from "@/lib/format";
import { toast } from "sonner";

export function SentenceModal({ direction, state, remaining, onClose }) {
  const [qty, setQty] = useState("");
  const [busy, setBusy] = useState(false);
  const n = Number(qty);
  const active = !!state?.active;
  const max = direction === "extend"
    ? Math.max(0, Math.floor(((state?.start_minutes || 0) * 60 - remaining) / 60))
    : Math.floor(remaining / 60);
  const valid = active && Number.isInteger(n) && n >= 1 && n <= max;
  const sign = direction === "extend" ? "+" : "−";

  const pay = async () => {
    if (!valid || busy) return;
    setBusy(true);
    try {
      const { data } = await api.post("/sentence/checkout", { direction, minutes: n, origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
      setBusy(false);
    }
  };

  const field = { background: "transparent", border: "1px solid var(--border)", color: "var(--text-primary)" };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6 fade-in" style={{ background: "rgba(0,0,0,0.75)" }} onClick={onClose} data-testid="sentence-modal-overlay">
      <div className="w-full max-w-sm p-8" style={{ background: "var(--bg-modal)", border: "1px solid var(--border)" }} onClick={(e) => e.stopPropagation()} data-testid="sentence-modal">
        <div className="flex justify-between items-start mb-6">
          <span className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }} data-testid="sentence-modal-title">{direction}</span>
          <button onClick={onClose} data-testid="sentence-modal-close" className="text-sm opacity-60 hover:opacity-100" style={{ color: "var(--text-primary)" }}>[ close ]</button>
        </div>
        {!active ? (
          <p className="font-head text-lg" style={{ color: "var(--accent)" }} data-testid="sentence-not-started">{state?.paused ? "clock paused" : "sentence not started"}</p>
        ) : (
          <>
            <label className="text-xs uppercase tracking-widest block" style={{ color: "var(--text-muted)" }}>how many minutes</label>
            <input data-testid="sentence-qty-input" type="number" min={1} value={qty} onChange={(e) => setQty(e.target.value.replace(/[^0-9]/g, ""))} onKeyDown={(e) => e.key === "Enter" && pay()} placeholder="1" className="w-full px-4 py-3 mt-2" style={field} />
            <p className="text-xs mt-2" style={{ color: "var(--text-muted)" }}>1 minute = 1 CAD</p>
            <p className="text-xs mt-1" style={{ color: "var(--text-muted)" }} data-testid="sentence-max">max {max} minutes</p>
            <p className="font-head text-xl mt-6" style={{ color: "var(--text-primary)" }} data-testid="sentence-total">
              {sign}{valid ? n : 0} minutes · ${valid ? n.toFixed(2) : "0.00"} CAD
            </p>
          </>
        )}
        <button onClick={pay} disabled={!valid || busy} data-testid="sentence-pay-btn" className="btn w-full py-3 mt-6 text-sm tracking-widest">{busy ? "…" : "PAY"}</button>
      </div>
    </div>
  );
}
